import { Calendar } from "lucide-react";

const blogPosts = [
  {
    id: 1,
    title: "Create Wealth Without All Work",
    excerpt:
      "Learn how to build wealth through systematic investment planning and smart financial decisions...",
    date: "15th March 2024",
    image:
      "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&h=250",
    alt: "Financial planning documents",
  },
  {
    id: 2,
    title: "Explore Specialization: All About",
    excerpt:
      "Discover specialized investment strategies and portfolio management techniques for optimal returns...",
    date: "12th March 2024",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&h=250",
    alt: "Digital banking interface",
  },
  {
    id: 3,
    title: "Corpus Spend Wisely: All About",
    excerpt:
      "Learn smart strategies for spending your retirement corpus and ensuring long-term financial security...",
    date: "10th March 2024",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&h=250",
    alt: "Couple reviewing retirement plans",
  },
];

export const BlogSection = () => {
  return (
    <section className="container mx-auto my-4 w-full rounded-lg bg-white p-4 px-4 sm:p-0 md:my-8 lg:my-16 lg:rounded-[30px] lg:px-10">
      <div className="flex w-full flex-col items-center justify-start gap-8 lg:gap-12">
        <h2 className="text-center font-nunito text-2xl font-bold leading-tight text-[#266985] sm:text-3xl lg:text-5xl lg:leading-[60px]">
          Blogs
        </h2>

        <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {blogPosts.map(post => (
            <article
              key={post.id}
              className="group cursor-pointer overflow-hidden rounded-xl border border-slate-100 bg-white shadow-md transition-all duration-300 hover:shadow-lg"
              data-testid={`blog-${post.id}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={post.image}
                  alt={post.alt}
                  className="h-48 w-full object-cover transition-transform duration-300 group-hover:scale-105 sm:h-52 lg:h-48"
                />
              </div>
              <div className="p-4 sm:p-5 lg:p-6">
                <h3 className="mb-2 font-nunito font-bold text-[#2F363F] transition-colors group-hover:text-primary sm:text-xl">
                  {post.title}
                </h3>
                <p className="mb-4 font-nunito text-[16px] font-medium leading-relaxed text-[#707070]">
                  {post.excerpt}
                </p>
                <div className=". flex items-center gap-2 text-xs text-neutral-400">
                  <Calendar className="mr-2 h-9 w-9 flex-shrink-0 rounded-[6px] bg-[#E4FFFB] p-2 text-[#266985]" />
                  <span className="font-nunito text-[16px] font-bold text-[#266985]">
                    {post.date}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
